import {Injectable} from '@angular/core';
import {getBlob, getDownloadURL, getStorage, ref, uploadBytes} from "@angular/fire/storage";

@Injectable({
  providedIn: 'root'
})
export class ImageService {
  storage = getStorage();

  constructor() { }

  async retrieveBlobFromStorage(imageUrl: string): Promise<{ imageName: string, blob: Blob}> {
    const imageRef = ref(this.storage, imageUrl);
    const imageName = imageRef.fullPath;

    const blob = await getBlob(imageRef);

    return { imageName, blob };
  }

  async uploadToStorage(imageName: string, file: File): Promise<string> {
    const imageRef = ref(this.storage, imageName);
    let uploadRef = "Image wasn't uploaded successfully";

    await uploadBytes(imageRef, file).then(async (snapshot) => {
      await getDownloadURL(snapshot.ref).then((downloadURL) => {
        uploadRef = downloadURL;
      });
    });
    return uploadRef;
  }

  /**
   * Replace the Firebase image URL with a relative URL endpoint to use NgOptimizedImage
   *
   * @param imageUrl Absolute Firebase Storage URL path
   */
  getRelativeURL(imageUrl: string): string {
    return imageUrl.replace("https://firebasestorage.googleapis.com",'');
  }
}
